import React, { Component } from 'react';
import ButtonIcon from "../../../../button";

class LineItemsLayoutComponent extends Component {

    render() {
        const { isReadOnly } = this.props

        return (
            <div className="details-container">
                <div className="button-header__alignment">
                    <ButtonIcon
                        onClick={!isReadOnly ? this.props.extractEBillData : () => { }}
                        iconLeft="cloud-arrow-down"
                        iconSize="17px"
                        customClassName={`${!isReadOnly ? "header-option-list" : ""} header-filter-button`}
                        labelName="E-Bill"
                        isDisable={isReadOnly}
                    />

                <ButtonIcon onClick={() => { this.props.viewSearchAction() }} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Search"/>

                <ButtonIcon
                        onClick={!isReadOnly ? this.props.extractAction : () => { }}
                        iconLeft="cloud-arrow-down" iconSize="17px"
                        customClassName={`${!isReadOnly ? "header-option-list" : ""} header-filter-button`}
                        isDisable={isReadOnly}
                        labelName="Extract List"
                />
                </div>
                {this.props.children} 
            </div>
        );
    }
}


export default LineItemsLayoutComponent;